import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { courseAPI } from '../../services/api';
import { Course } from '../../types';
import '../../styles/shared.css';
import './CourseList.css';

const CourseList: React.FC = () => {
  const [courses, setCourses] = useState<Course[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    setLoading(true);
    try {
      const response = await courseAPI.getCourses({
        page: 1,
        limit: 50,
      });
      
      setCourses(response.courses);
    } catch (error) {
      console.error('Failed to fetch courses:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case '正常': return '报名中';
      case '转出': return '已满员';
      case '过期': return '已结束';
      case '退课': return '已取消';
      case 'active': return '报名中';
      case 'full': return '已满员';
      case 'ended': return '已结束';
      case 'cancelled': return '已取消';
      default: return status;
    }
  };

  const getStatusBadgeClass = (status: string) => {
    switch (status) {
      case '正常':
      case 'active': return 'status-normal';
      case '转出':
      case 'full': return 'status-transferred';
      case '过期':
      case 'ended': return 'status-expired';
      case '退课':
      case 'cancelled': return 'status-cancelled';
      default: return 'status-normal';
    }
  };


  const formatSchedule = (course: Course) => {
    if (!course.startDate || !course.endDate) {
      return '时间待定';
    }
    
    const startDate = new Date(course.startDate).toLocaleDateString();
    const endDate = new Date(course.endDate).toLocaleDateString();
    
    let timeInfo = `${startDate} 至 ${endDate}`;
    
    // Add class time description if available
    if ((course as any).classTimeDescription) {
      timeInfo += ` \n${(course as any).classTimeDescription}`;
    }
    
    return timeInfo;
  };

  return (
    <div className="page-container course-list-page">
      <div className="page-header">
        <div className="header-content">
          <h1>课程列表</h1>
        </div>
      </div>

      <div className="content-container">
        {loading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>加载中...</p>
          </div>
        ) : courses.length === 0 ? (
          <div className="empty-container">
            <div className="empty-content">
              <div className="empty-icon">📚</div>
              <p className="empty-text">暂无相关课程</p>
            </div>
          </div>
        ) : (
          <div className="courses-list">
            {courses.map(course => (
              <Link key={course.id} to={`/courses/${course.id}`} className="course-card-link">
                <div className="course-card">
                  <div className="course-header">
                    <h3 className="course-name">{course.name}</h3>
                    <span className={`status-badge ${getStatusBadgeClass(course.status)}`}>
                      {getStatusText(course.status)}
                    </span>
                  </div>

                  <div className="course-tags">
                    <span className="course-tag">{course.category || '综合'}</span>
                  </div>

                  <div className="course-details">
                    <div className="detail-item">
                      <span className="label">时间:</span>
                      <span className="content">
                        {formatSchedule(course)}
                      </span>
                    </div>
                    <div className="detail-item">
                      <span className="label">地点:</span>
                      <span className="content">{course.location}</span>
                    </div>
                    <div className="detail-item">
                      <span className="label">课节:</span>
                      <span className="content">{course.totalLessons}节</span>
                    </div>
                    <div className="detail-item teacher-info">
                      <span className="label">讲师:</span>
                      <span className="content">
                        <img 
                          className="teacher-avatar"
                          src={course.teacherAvatar || "https://img01.yzcdn.cn/vant/cat.jpeg"} 
                          alt={course.teacherName || '讲师'} 
                        />
                        <span>{course.teacherName || '专业讲师'}</span>
                      </span>
                    </div>
                  </div>

                  <div className="course-footer">
                    <div className="price-info">
                      <span className="current-price">¥{course.price}</span>
                      <span className="original-price">¥{Math.round(course.price * 1.2)}</span>
                    </div>
                    <div className="enrollment-info">
                      <span>{course.currentStudents || 0}人已报名</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CourseList;